import React from 'react';
import soon from '../assets/img/soon.gif';
import LottieAnimation2 from '../components/ui/LottieAnimation2.jsx';
import PrimaryButton from '../components/ui/PrimaryButton';
import SecondaryButton from '../components/ui/SecondaryButton';
import { useNavigate } from 'react-router-dom';
import LayeredDashboardHeader from './LayeredDashboardHeader';
const Soon = ({ tab }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/dashboard/setup');
  }
  const handleClickBack = () => {
    navigate(-1);
  }
  return (
    <>
      <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
      <div className='w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible'>
        <div>
          <div className='w-[100%] h-[calc(100dvh-70px)] flex-col bg-white overflow-auto flex justify-center items-center'>
            <div className='flex flex-col justify-center items-center'>
              <div className='relative  max-w-[480px] max-h-[480px] w-[100%] h-[100%]'>
                <LottieAnimation2 />

              </div>
              <div className='mt-[40px] flex flex-col justify-center items-center'>
                <span className='text-[#7059EF] font-extrabold text-[36px] '>GELİŞTİRMEYE DEVAM EDİYORUZ.</span>
                <span className='text-[#8A92A6] text-[16px] font-medium h-[60px] mt-[15px]'>Bu sayfayı çok yakında yayınlayacağız.</span>
                <div className='flex items-center gap-[25px]'>
                  <SecondaryButton onClick={handleClickBack} value={"Önceki Sayfaya Geri Dön"} />
                  <PrimaryButton onClick={handleClick} value={"Girişe Geri Dön"} />
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

    </>
  )
}

export default Soon